import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-500c46d3"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["accept"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("input", {
    multiple: "",
    type: "file",
    ref: "refName",
    class: "inputFile_container cursor-p",
    onChange: _cache[0] || (_cache[0] = (...args) => $options.changefile && $options.changefile(...args)),
    title: "",
    accept: $options.accept
  }, null, 40, _hoisted_1);
}